/** Id de la organización seleccionada en localStorage (string o null). */
export const getSelectedOrganizationId = () => localStorage.getItem('organizationId');

/** Nombre de la organización seleccionada. */
export const getSelectedOrganizationName = () => localStorage.getItem('companyFilter');

/**
 * Si falta organizationId (sesión anterior), lo resuelve desde companies + companyFilter.
 */
export const ensureOrganizationId = () => {
  const existing = localStorage.getItem('organizationId');
  if (existing != null && existing !== '' && existing !== 'undefined') {
    return existing;
  }

  try {
    const companies = JSON.parse(localStorage.getItem('companies') || '[]');
    const name = localStorage.getItem('companyFilter');
    const match = companies.find((company) => company.name === name);
    if (match?.id != null) {
      localStorage.setItem('organizationId', match.id);
      return String(match.id);
    }
  } catch {
    // companies inválido en localStorage
  }
  return null;
};

/**
 * True si el item pertenece a la organización seleccionada.
 * Prioriza organization_id (sobrevive renombres); si no hay id, usa el nombre.
 */
export const matchesSelectedOrganization = (item, nameKey = 'organization') => {
  const selectedId = ensureOrganizationId();
  const itemId = item?.organization_id;

  if (
    selectedId != null &&
    selectedId !== '' &&
    itemId != null &&
    itemId !== ''
  ) {
    return Number(itemId) === Number(selectedId);
  }

  return item?.[nameKey] === getSelectedOrganizationName();
};
